<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="400px" lazy>
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("contract") }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text style="max-height: 220px; overflow-y: auto;">
                    <v-container grid-list-md py-0>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="contractNum"
                                    :label="`${$t('contractNumber')} *`"
                                    required>
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="contractName"
                                    :label="`${$t('name')} *`"
                                    required>
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <small>{{ $t("requiredFieldPointer") }}</small>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="saveDataClick">{{ $t("save") }}</v-btn>
                    <v-btn color="error" @click="cancelClick">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <message-box ref="MessageBox"/>
    </v-layout>
</template>

<script>
    import MessageBox from "./MessageBox";

    export default {
        name: "EditContractDialog",

        components: {
            MessageBox
        },

        data () {
            return {
                dialog:      false,
                dataUpdated: false,
                contractNum: "",
                contractName: "",
                saveData:    false,
            }
        },

        methods: {
            /**
             * Сброс параметров формы
             */
            resetForm () {
                this.contractNum  = "";
                this.contractName = "";
            },

            /**
             * Обработчик нажатия кнопки отмены
             */
            cancelClick () {
                this.saveData = false;
                this.dialog   = false;
            },

            /**
             * Обработчик нажатия кнопки сохранения
             */
            saveDataClick () {
                this.saveData = true;
                this.dialog   = false;
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            /*
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            }
            */
        }
    }
</script>
